// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"connectBotton_buttonWrapper__5SbA8"};